/**
 * Picks a random element. The non-empty tuple parameter is what makes the
 * return type non-optional, so callers need no undefined check.
 */
export function pickRandom(values) {
    const value = values[Math.floor(Math.random() * values.length)];
    if (value === undefined) {
        throw new Error("Random selection fell outside the supplied values");
    }
    return value;
}
// Utility function to get the initials from a name.
export function getNameInitials(name) {
    return name
        .split(" ")
        .filter((n) => n.trim())
        .slice(0, 2)
        .map((n) => n.charAt(0).toUpperCase())
        .join("");
}
/**
 * Converts a base64-encoded CSV string to a data URI.
 *
 * @param data - Base64-encoded CSV string.
 * @returns Data URI for the CSV file.
 */
export function getDataUriFromCsvResponse(data) {
    const decodedCsv = new TextDecoder("utf-8").decode(Uint8Array.from(atob(data), (c) => c.charCodeAt(0)));
    // Add a UTF-8 BOM to ensure compatibility with Excel
    const bom = "\uFEFF";
    const utf8Csv = bom + decodedCsv;
    const blob = new Blob([utf8Csv], {
        type: "text/csv;charset=utf-8;",
    });
    return URL.createObjectURL(blob);
}
//# sourceMappingURL=utils.js.map